var map = {
	"./10-gm-achieved.png": 407,
	"./10-gm-achieved.svg": 123,
	"./10-gm-achieved_old.svg": 368,
	"./10-gm-unachieved.jpg": 567,
	"./10-gm-unachieved.png": 122,
	"./10-gm-unachieved_old.svg": 369,
	"./10000-gift-voucher.svg": 211,
	"./10gm-gold-coin.svg": 212,
	"./10k-Gift-Voucher.svg": 370,
	"./10k-achieved.svg": 127,
	"./10k-unachieved.svg": 126,
	"./10l-act.svg": 106,
	"./10l-inact.svg": 173,
	"./1l-act.svg": 177,
	"./1l-inact.svg": 171,
	"./1st.svg": 166,
	"./25l-act.svg": 179,
	"./25l-inact.svg": 174,
	"./2nd.svg": 167,
	"./3000-gift-voucher.svg": 213,
	"./3k-achieved.svg": 129,
	"./3k-unachieved.svg": 128,
	"./3l-act.svg": 178,
	"./3l-inact.svg": 172,
	"./3rd.svg": 168,
	"./404.png": 268,
	"./5-gm-achieved.svg": 125,
	"./5-gm-achieved_old.svg": 371,
	"./5-gm-unachieved.svg": 124,
	"./5-gm-unachieved_old.svg": 372,
	"./502.png": 269,
	"./5gm-gold-coin.svg": 214,
	"./5l-act.svg": 373,
	"./5l-inact.svg": 374,
	"./Arrow Back2x.png": 408,
	"./Astra/Blue.gif": 360,
	"./Astra/Brown.gif": 361,
	"./Astra/Green.gif": 362,
	"./Astra/Retailer/R0.png": 109,
	"./Astra/Retailer/R10.png": 181,
	"./Astra/Retailer/R100.gif": 294,
	"./Astra/Retailer/R100.png": 182,
	"./Astra/Retailer/R20.png": 183,
	"./Astra/Retailer/R30.png": 184,
	"./Astra/Retailer/R40.png": 185,
	"./Astra/Retailer/R50.png": 186,
	"./Astra/Retailer/R60.png": 187,
	"./Astra/Retailer/R70.png": 188,
	"./Astra/Retailer/R80.png": 189,
	"./Astra/Retailer/R90.png": 190,
	"./Astra/Sale/S0.png": 108,
	"./Astra/Sale/S10.png": 191,
	"./Astra/Sale/S100.gif": 295,
	"./Astra/Sale/S100.png": 192,
	"./Astra/Sale/S100_1.gif": 296,
	"./Astra/Sale/S20.png": 193,
	"./Astra/Sale/S30.png": 194,
	"./Astra/Sale/S40.png": 195,
	"./Astra/Sale/S50.png": 196,
	"./Astra/Sale/S60.png": 197,
	"./Astra/Sale/S70.png": 198,
	"./Astra/Sale/S80.png": 199,
	"./Astra/Sale/S90.png": 200,
	"./Astra/Service/SE0.png": 110,
	"./Astra/Service/SE10.png": 201,
	"./Astra/Service/SE100.gif": 297,
	"./Astra/Service/SE100.png": 202,
	"./Astra/Service/SE20.png": 203,
	"./Astra/Service/SE30.png": 204,
	"./Astra/Service/SE40.png": 205,
	"./Astra/Service/SE50.png": 206,
	"./Astra/Service/SE60.png": 207,
	"./Astra/Service/SE70.png": 208,
	"./Astra/Service/SE80.png": 209,
	"./Astra/Service/SE90.png": 210,
	"./Astra/a.png": 298,
	"./Astra/blueline.png": 299,
	"./Astra/brownline.png": 300,
	"./Astra/greenline.png": 301,
	"./BKB-Elements/1st-final.gif": 568,
	"./BKB-Elements/Asta Hole.png": 409,
	"./BKB-Elements/Astra bg.png": 410,
	"./BKB-Elements/Bg img 2.png": 411,
	"./BKB-Elements/Congratulations text.svg": 375,
	"./BKB-Elements/Final milestone.png": 412,
	"./BKB-Elements/FullStone.png": 180,
	"./BKB-Elements/Group 12090.png": 413,
	"./BKB-Elements/Group_12090@2x.svg": 376,
	"./BKB-Elements/Individual rank card.svg": 377,
	"./BKB-Elements/Milestone 10L.svg": 80,
	"./BKB-Elements/Milestone 1L.svg": 65,
	"./BKB-Elements/Milestone 25L.svg": 67,
	"./BKB-Elements/Milestone 5L.svg": 66,
	"./BKB-Elements/Rank table card.svg": 378,
	"./BKB-Elements/Rank.png": 170,
	"./BKB-Elements/Rank_top_nav_bar_bg1.svg": 379,
	"./BKB-Elements/Rank_top_nav_bar_bg2.png": 414,
	"./BKB-Elements/Rank_top_nav_bar_button.png": 137,
	"./BKB-Elements/Stone-1.gif": 357,
	"./BKB-Elements/Stone-2.gif": 358,
	"./BKB-Elements/Stone-3.gif": 359,
	"./BKB-Elements/Target Bar.svg": 380,
	"./BKB-Elements/Total poitns card.svg": 381,
	"./BKB-Elements/You have earned 100% bonus point (final popup).svg": 382,
	"./BKB-Elements/bg.gif": 332,
	"./BKB-Elements/bg.png": 415,
	"./BKB-Elements/bg_astra.png": 416,
	"./BKB-Elements/bg_gif.gif": 569,
	"./BKB-Elements/bg_new.png": 136,
	"./BKB-Elements/bonus icon.svg": 383,
	"./BKB-Elements/full_stone.png": 318,
	"./BKB-Elements/milestone-progress-bar.svg": 384,
	"./BKB-Elements/ok_button.png": 319,
	"./BKB-Elements/p1.svg": 46,
	"./BKB-Elements/points-bar.png": 417,
	"./BKB-Elements/points_bar.png": 418,
	"./BKB-Elements/profile-bg.svg": 385,
	"./BKB-Elements/retailer_bg.gif": 354,
	"./BKB-Elements/sale_bg.gif": 355,
	"./BKB-Elements/service_bg.gif": 356,
	"./Calendar-icon.png": 149,
	"./CanonBig.gif": 227,
	"./Cash_Collection.png": 277,
	"./Daily_invest.png": 279,
	"./Ended.svg": 118,
	"./Impact_player_screen/CompletedAstra/blank.png": 320,
	"./Impact_player_screen/CompletedAstra/unnamed.png": 419,
	"./Impact_player_screen/CompletedAstra/with_text.png": 215,
	"./Impact_player_screen/CompletedAstra/with_text_old.png": 420,
	"./Impact_player_screen/Onboarding_screen/Frame 11778.gif": 570,
	"./Impact_player_screen/Onboarding_screen/Screen1.gif": 489,
	"./Impact_player_screen/Onboarding_screen/Screen2.png": 321,
	"./Impact_player_screen/Onboarding_screen/Screen3.gif": 490,
	"./Impact_player_screen/Onboarding_screen/live_war.gif": 291,
	"./Impact_player_screen/Onboarding_screen/normal_day.png": 176,
	"./Impact_player_screen/Onboarding_screen/two_days_back.png": 216,
	"./Impact_player_screen/home_screen/ArrowBack.png": 322,
	"./Impact_player_screen/home_screen/Back_to_Home.png": 323,
	"./Impact_player_screen/home_screen/Border_daily_points.png": 138,
	"./Impact_player_screen/home_screen/Daily_total_points_bg.png": 421,
	"./Impact_player_screen/home_screen/EnterBKB.png": 324,
	"./Impact_player_screen/home_screen/Group 12457.png": 422,
	"./Impact_player_screen/home_screen/Group 12462.png": 423,
	"./Impact_player_screen/home_screen/Group_12509.png": 290,
	"./Impact_player_screen/home_screen/Impact ranking.png": 424,
	"./Impact_player_screen/home_screen/Points_being_collected.gif": 327,
	"./Impact_player_screen/home_screen/Points_being_collected_pld.gif": 486,
	"./Impact_player_screen/home_screen/Timer.png": 425,
	"./Impact_player_screen/home_screen/background.gif": 135,
	"./Impact_player_screen/home_screen/bg_daily_points.png": 426,
	"./Impact_player_screen/home_screen/claim_2x.png": 325,
	"./Impact_player_screen/home_screen/impact_player.png": 427,
	"./Impact_player_screen/home_screen/impact_player_bonus.png": 428,
	"./Impact_player_screen/home_screen/misile.gif": 487,
	"./Impact_player_screen/home_screen/movingFullStone.gif": 328,
	"./Impact_player_screen/home_screen/mumbai.png": 130,
	"./Impact_player_screen/home_screen/next_icon.png": 217,
	"./Impact_player_screen/home_screen/points_bg.png": 429,
	"./Impact_player_screen/home_screen/ranking_bg.png": 219,
	"./Impact_player_screen/home_screen/score card.svg": 386,
	"./Impact_player_screen/home_screen/stamp_2x.gif": 329,
	"./Impact_player_screen/home_screen/stamp_5x.gif": 330,
	"./Impact_player_screen/home_screen/war_day_bg.gif": 488,
	"./Impact_player_screen/live.png": 175,
	"./Individual_leaderboard.png": 169,
	"./Normal-dist/Arrow_back.png": 326,
	"./Normal-dist/Business_pe_pakad.gif": 571,
	"./Normal-dist/Rectangle_bg.svg": 387,
	"./Normal-dist/Rectangle_bg_1.png": 430,
	"./Normal-dist/Rectangle_blue_1.svg": 388,
	"./Normal-dist/Rectangle_blue_2.png": 431,
	"./Normal-dist/Rectangle_yellow_1.svg": 389,
	"./Normal-dist/Rectangle_yellow_2.png": 432,
	"./Normal-dist/retailer_astra_btn.png": 433,
	"./Normal-dist/retailer_astra_btn_1.png": 434,
	"./Normal-dist/saleastra_bg.png": 435,
	"./Normal-dist/saleastra_btn.png": 436,
	"./Normal-dist/service_astra.png": 437,
	"./Normal-dist/service_astra_btn.png": 438,
	"./Payment_Gateway.png": 278,
	"./Point-logo.png": 53,
	"./Points-box.png": 98,
	"./RefreshSVG.svg": 390,
	"./See-all.png": 439,
	"./Stone-3-with--BG-min.gif": 572,
	"./Utility.png": 158,
	"./ViewDetails.svg": 391,
	"./WarLeaderboard.png": 440,
	"./Wars-won-icon.png": 273,
	"./aeps.png": 159,
	"./all_rounder.png": 441,
	"./animation/1.gif": 573,
	"./animation/10.gif": 574,
	"./animation/11.gif": 575,
	"./animation/12.gif": 576,
	"./animation/13.gif": 577,
	"./animation/14.gif": 578,
	"./animation/15.gif": 579,
	"./animation/16.gif": 580,
	"./animation/17.gif": 581,
	"./animation/18.gif": 582,
	"./animation/19.gif": 583,
	"./animation/2.gif": 584,
	"./animation/20.gif": 585,
	"./animation/21.gif": 586,
	"./animation/22.gif": 587,
	"./animation/3.gif": 588,
	"./animation/4.gif": 589,
	"./animation/5.gif": 590,
	"./animation/6.gif": 591,
	"./animation/7.gif": 592,
	"./animation/8.gif": 593,
	"./animation/9.gif": 594,
	"./arrow-right.svg": 105,
	"./asc.svg": 285,
	"./atm.png": 160,
	"./awtar-image.png": 221,
	"./back-blue.png": 119,
	"./back.png": 37,
	"./background/000_background.gif": 595,
	"./background/001_background.gif": 596,
	"./background/010_background.gif": 597,
	"./background/011_background.gif": 598,
	"./background/100_background.gif": 599,
	"./background/101_background.gif": 600,
	"./background/110_background.gif": 601,
	"./background/111_background.gif": 602,
	"./battle-has-begun.svg": 392,
	"./battle-leaderboard.svg": 287,
	"./battle-over.svg": 393,
	"./bg.png": 442,
	"./bill_payment.png": 443,
	"./bkb-header.png": 289,
	"./bkb-leaderboard-header.png": 444,
	"./bkb3-gifts.png": 218,
	"./black-back.svg": 394,
	"./bonus.svg": 284,
	"./bonus_icon.svg": 395,
	"./bor-img.svg": 288,
	"./cannonsmallbottomnew.png": 99,
	"./canon-catapult-Front-view.gif": 228,
	"./canonbigbottom.png": 100,
	"./canonsmallbottom.png": 445,
	"./card-bg-img-2.svg": 396,
	"./card-bg-img.svg": 397,
	"./cash_rotation_bonus.png": 446,
	"./cashdrop.png": 447,
	"./chat_black.png": 448,
	"./clock.png": 449,
	"./close.png": 45,
	"./congo-profile.png": 254,
	"./congratulation.png": 253,
	"./crown.png": 248,
	"./daily_invest.png": 450,
	"./datebox.png": 293,
	"./defaultProfile.png": 43,
	"./desc.svg": 121,
	"./dhanak.png": 157,
	"./dhanakHub.png": 281,
	"./dhanakRefurb.png": 280,
	"./dhanak_accessories.png": 451,
	"./dmt.png": 161,
	"./down-thumb.png": 252,
	"./down.png": 64,
	"./downLoadMore.png": 452,
	"./dpos.png": 453,
	"./dth.png": 275,
	"./faq-icon.png": 94,
	"./faq.png": 60,
	"./faq1.png": 257,
	"./flight.png": 276,
	"./flights.png": 263,
	"./gatway.png": 454,
	"./gatway_portal.png": 455,
	"./group-chat-arrow.png": 148,
	"./icons-transaction-pending/aeps.png": 302,
	"./icons-transaction-pending/bill_payment.png": 303,
	"./icons-transaction-pending/cashdrop.png": 304,
	"./icons-transaction-pending/daily_invest.png": 305,
	"./icons-transaction-pending/dhanak.png": 306,
	"./icons-transaction-pending/dmt.png": 307,
	"./icons-transaction-pending/dpos.png": 308,
	"./icons-transaction-pending/flights.png": 309,
	"./icons-transaction-pending/gatway.png": 310,
	"./icons-transaction-pending/irctc.png": 311,
	"./icons-transaction-pending/micro_atm.png": 312,
	"./icons-transaction-pending/mpos.png": 313,
	"./icons-transaction-pending/pan_card.png": 314,
	"./icons-transaction-pending/ppi.png": 315,
	"./icons-transaction-pending/recharge.png": 316,
	"./icons-transaction-pending/trans_pending.png": 131,
	"./icons-transaction-pending/utility.png": 317,
	"./impact.png": 165,
	"./impact_bonus.png": 456,
	"./inReview.png": 117,
	"./insurance.png": 457,
	"./irctc.png": 282,
	"./jarvis/jpeg/user.jpeg": 603,
	"./jarvis/png/chatbot.png": 96,
	"./jarvis/png/graph_placeholder.png": 222,
	"./jarvis/png/graph_placeholder_1.png": 223,
	"./jarvis/png/jarvis_bg.png": 112,
	"./jarvis/png/table_placeholder.png": 224,
	"./jarvis/png/user.png": 139,
	"./jarvis/svg/cancel_close.svg": 220,
	"./kingdom.png": 458,
	"./leaderboard.png": 459,
	"./left-arrow-black.png": 120,
	"./level-icon.png": 460,
	"./live.png": 292,
	"./live.svg": 116,
	"./loading.gif": 604,
	"./lock.png": 461,
	"./lose-profile.png": 256,
	"./lose.png": 255,
	"./loser.png": 462,
	"./lost-icon.png": 251,
	"./membership.png": 463,
	"./micro_atm.png": 464,
	"./middle-icon.png": 465,
	"./mpos.png": 466,
	"./other.png": 93,
	"./pan_card.png": 283,
	"./pay-point-icon.svg": 95,
	"./pay1-points-fixed-icon.svg": 398,
	"./pay1-points-img.svg": 54,
	"./points-animationgif.gif": 605,
	"./ppi.png": 467,
	"./rank-act.svg": 399,
	"./rank-inact.svg": 400,
	"./recharge.png": 162,
	"./refresh-white.svg": 286,
	"./refresh.png": 247,
	"./right-arrow.png": 147,
	"./right-white.png": 163,
	"./right.png": 468,
	"./rm-chat-icon.svg": 401,
	"./rm-history.svg": 402,
	"./rm-you-lose.svg": 270,
	"./rm-you-won.svg": 271,
	"./saarthi_bonus.png": 469,
	"./saarthi_bonus_points.png": 470,
	"./score-board-gif.gif": 142,
	"./search.png": 274,
	"./send.png": 244,
	"./share-kd-right.png": 164,
	"./share.png": 272,
	"./slider-bkb.png": 265,
	"./slider-kingdom.png": 266,
	"./slider-war.png": 267,
	"./sort-icon.png": 471,
	"./standings.png": 472,
	"./stat-arrow-red.png": 103,
	"./stat-arrow.png": 104,
	"./stats.png": 473,
	"./sword.gif": 606,
	"./thumb.png": 250,
	"./tips_and_updates.png": 474,
	"./topup.png": 475,
	"./topup.svg": 403,
	"./up.png": 30,
	"./upLoadMore.png": 476,
	"./utility (2).png": 477,
	"./utility.png": 478,
	"./utility_portal.png": 479,
	"./war-began.png": 480,
	"./war.png": 481,
	"./war_points.png": 264,
	"./warzone-icon.png": 258,
	"./wealth-Icon.png": 482,
	"./winner.png": 483,
	"./won-icon.png": 249,
	"./ws-gc-icon.svg": 404,
	"./ws-vd-icon.svg": 405,
	"./you-lose-home.png": 145,
	"./you-lose-war-page.png": 484,
	"./you-won-home.png": 144,
	"./you-won-war-page.png": 485
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 132;